"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _entities = _interopRequireDefault(require("./entities"));

var _modalInteractions = _interopRequireDefault(require("./modalInteractions"));

var _stagedWorkspaceInfo = _interopRequireDefault(require("./stagedWorkspaceInfo"));

var _workspacesTableInteractions = _interopRequireDefault(require("./workspacesTableInteractions"));

var _workspaceMembersTableInteractions = _interopRequireDefault(require("./workspaceMembersTableInteractions"));

var _workspacesAudits = _interopRequireDefault(require("./workspacesAudits"));

var _default = (0, _redux.combineReducers)({
  entities: _entities.default,
  modalInteractions: _modalInteractions.default,
  stagedWorkspaceInfo: _stagedWorkspaceInfo.default,
  workspacesTableInteractions: _workspacesTableInteractions.default,
  workspaceMembersTableInteractions: _workspaceMembersTableInteractions.default,
  workspacesAudits: _workspacesAudits.default
});

exports.default = _default;
module.exports = exports.default;